import * as SiteManager from '../domain/site-manager';
import React from 'react';
import { useData, dataFromDataset } from './DataProviderCache';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { Data } from '../../types/data-providers';
import { SiteProfile } from '../../types';

type ContextState = Data<SiteProfile>;

const Context = React.createContext<ContextState | null>(null);

function useSiteProfileData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useSiteProfileData must be used within a SiteProfileDataProvider');
    }
    return contextState;
}

const SiteProfileDataProvider: React.FC<{ siteId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'site-profile-data',
        id: props.siteId,
        dataFn: React.useCallback(
            () => SiteManager.getSiteProfile(authHelper, props.siteId),
            [authHelper, props.siteId]
        ),
    });
    const siteProfileData = dataFromDataset(dataset);

    return <Context.Provider value={siteProfileData}>{props.children}</Context.Provider>;
};

const TestSiteProfileDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { SiteProfileDataProvider, TestSiteProfileDataProvider, useSiteProfileData };
